<script lang="ts">
import { defineComponent } from 'vue'
import SelectorCore from '@/components/form/SelectorCore.vue'
const { props, emits } = SelectorCore

export default defineComponent({
  name: 'SelectorDefault',

  components: {
    SelectorCore,
  },

  props,

  emits,
})
</script>

<template>
  <SelectorCore
    :model-value="modelValue"
    :items="items"
    :name="name"
    :unit="unit"
    :is-disabled="isDisabled"
    :default-selector-label="defaultSelectorLabel"
    :default-selector-value="defaultSelectorValue"
    :inline="inline"
    :is-error="isError"
    @change="$emit('change', $event)"
    @update:model-value="$emit('update:modelValue', $event)" />
</template>

/**
 * SelectorDefault.vue の scoped style を上書くために deep 修飾子を使用。
 * @see https://zenn.dev/karan_coron/articles/87597250de406018e351
 */
<style lang="sass" deep>
.o-selector
  $root: &
  width: 100%
  display: block
  margin:
    top: 14px
    left: 0
    right: auto

  &:first-child
    margin-top: 0

  & &--label
    width: 100%
    display: inline-block
    vertical-align: middle
    position: relative
    +transition

    &::after
      +iconTriangle(down)
      position: absolute
      top: 50%
      right: 10px
      transform: translateY(-50%)

  & &--items
    width: 100%
    padding: 0.6em 30px 0.6em 1em
    background-color: rgba($bg-xx-light-cyan, 1)
    border: 1px solid $border-xx-light-cyan
    border-radius: $border-radius
    cursor: pointer
    +transition

    +mouseover
      border-color: $border-light-cyan

    &:focus
      background-color: $bg-white
      border-color: $border-light-cyan
      box-shadow: $box-shadow

    &:disabled
      border-color: $border-xx-light-cyan
      cursor: default

  &.is-inline
    width: auto
    display: inline-block

  &[data-disabled="true"]
    #{$root}--label
      opacity: 0.4

      &::after
        opacity: 0.3

  &[data-error="true"]
    #{$root}--label
      &::after
        +iconTriangle(down, $border-error)

    #{$root}--items
      background-color: rgba($bg-error, 1)
      border-color: $border-error
</style>
